export const ADJUST_TITLE = {
  add: "新增",
  edit: "编辑",
  detail: "详情",
};

// 审核状态
export const PROCESS_STATUS = [
  {
    label: "待审核",
    value: "1",
  },
  {
    label: "审核中",
    value: "2",
  },
  {
    label: "审核通过",
    value: "3",
  },
  {
    label: "审核不通过",
    value: "4",
  },
];

//开票状态
export const PIAO_STATUS = [
  {
    label: "未开票",
    value: "0",
  },
  {
    label: "已开票",
    value: "1",
  },
];

// 审核状态 el-tag type
export const TAG_TYPE = {
  1: "primary",
  2: "primary",
  3: "success",
  4: "danger",
};

// 审批类型
export const APPROVAL_TYPE = [
  {
    label: "入库",
    value: "1",
  },
  // {
  //   label: "出库",
  //   value: "2",
  // },
  // {
  //   label: "盘点",
  //   value: "3",
  // },
  {
    label: "调拨",
    value: "4",
  },
  {
    label: "领料申请",
    value: "7",
  },
];

// 供应商状态
export const SUPPLIER_STATUS = [
  {
    label: "启用",
    value: "1",
  },
  {
    label: "停用",
    value: "2",
  },
];

// 物料用途
export const SUPPLIER_USE = [
  {
    label: "工程用料",
    value: "1",
  },
  {
    label: "生产用料",
    value: "2",
  },
];
